/* Choix de la langue de la vitrine : français par défaut, choix gardé dans le navigateur, puis la page se recharge
   (les scènes mesurent les textes au chargement). */
(() => {
  const NAMES = {"fr": "Français", "en": "English", "es": "Español", "de": "Deutsch", "it": "Italiano", "pt": "Português", "ar": "العربية", "zh": "中文"};
  const KEY = 'inv-vitrine-lang';
  let lang = 'fr';
  try { const s = localStorage.getItem(KEY); if (NAMES[s]) lang = s; } catch (e) {}
  if (lang === 'fr' && NAMES[window.name.replace('inv-lang:', '')] && window.name.startsWith('inv-lang:')) lang = window.name.slice(9);
  window.SITE_LANG = lang;
  document.documentElement.lang = lang;

  const css = document.createElement('style');
  css.textContent = `.lang-pick { position: fixed; z-index: 60; left: max(14px, env(safe-area-inset-left, 0px)); bottom: calc(14px + env(safe-area-inset-bottom, 0px));
      display: flex; align-items: center; gap: 6px; background: var(--lime); color: var(--lime-ink); border-radius: 999px; padding: 6px 12px;
      font: 500 12px/1 'DM Mono', ui-monospace, monospace; letter-spacing: .08em; box-shadow: 0 4px 18px rgb(0 0 0 / .35) }
    .lang-pick select { appearance: none; -webkit-appearance: none; border: 0; background: transparent; color: inherit; font: inherit; letter-spacing: inherit; padding: 2px 14px 2px 0; cursor: pointer;
      background-image: linear-gradient(45deg, transparent 50%, currentColor 50%), linear-gradient(-45deg, transparent 50%, currentColor 50%);
      background-size: 4px 4px; background-position: right 4px center, right 0 center; background-repeat: no-repeat }
    .lang-pick select:focus-visible { outline: 2px solid var(--lime-ink); outline-offset: 2px; border-radius: 4px }
    .lang-pick option { color: #1a1915; background: #fff }`;
  document.head.appendChild(css);

  const box = document.createElement('label');
  box.className = 'lang-pick';
  box.innerHTML = '<span aria-hidden="true">🌐</span>';
  const sel = document.createElement('select');
  sel.setAttribute('aria-label', 'Langue / Language');
  Object.entries(NAMES).forEach(([k, n]) => { const o = document.createElement('option'); o.value = k; o.textContent = n; if (k === lang) o.selected = true; sel.appendChild(o); });
  sel.addEventListener('change', () => {
    try { localStorage.setItem(KEY, sel.value); } catch (e) {}
    window.name = 'inv-lang:' + sel.value;
    location.reload();
  });
  box.appendChild(sel);
  document.body.appendChild(box);

  // Téléphone en portrait : images plein écran en version verticale (scène entière visible au lieu d'un tiers agrandi)
  if (matchMedia('(orientation: portrait) and (max-width: 820px)').matches) {
    document.addEventListener('DOMContentLoaded', () => {
      [['#grow1 img', VIMG('images/hero-m.jpg')], ['#grow2 img', VIMG('images/process-m.jpg')]].forEach(([q, src]) => { const i = document.querySelector(q); if (i) i.src = src; });
    });
  }

  // Arabe : sens de lecture de droite à gauche dans chaque bloc de texte (la mise en page animée reste la même)
  if (lang === 'ar') {
    const rtl = document.createElement('style');
    rtl.textContent = 'html[lang="ar"] :where(h1, h2, h3, p, figcaption, blockquote, .pstep) { unicode-bidi: plaintext } html[lang="ar"] #spotIntro, html[lang="ar"] .mw, html[lang="ar"] #heroLine1 { direction: rtl }';
    document.head.appendChild(rtl);
    // les mots de la devise sont découpés lettre par lettre pour l'animation : un liant invisible (ZWJ) garde les lettres attachées
    const NOLEFT = 'اأإآدذرزوؤةى';
    const joins = (c) => /[ؠ-ي]/.test(c);
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.mw').forEach((w) => {
        const sc = [...w.querySelectorAll('.sc')];
        sc.forEach((s, i) => {
          const c = s.textContent, prev = sc[i - 1] && sc[i - 1].textContent.slice(-1), next = sc[i + 1] && sc[i + 1].textContent[0];
          let t = c;
          if (prev && joins(prev) && !NOLEFT.includes(prev) && joins(c)) t = '‍' + t;
          if (next && joins(next) && joins(c) && !NOLEFT.includes(c)) t = t + '‍';
          s.textContent = t;
        });
      });
    });
  }
})();
